{{TR 'Aktuelle Anzahl Geräte'}}:&nbsp;<strong>{{device_count}}</strong></br>
{{#COMPARE device_count_ok '>' 0}}
<i class="fa fa-circle success m-r-5"></i>&nbsp;{{ device_count_ok }}</br>
{{/COMPARE}}
{{#COMPARE device_count_error '>' 0}}
<i class="fa fa-circle warning m-r-5"></i>&nbsp;{{ device_count_error }}</br>
{{/COMPARE}}
{{#COMPARE device_count_delayed '>' 0}}
<i class="fa fa-circle error m-r-5"></i>&nbsp;{{ device_count_delayed }}</br>
{{/COMPARE}}
